import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class TechnologieStromerzeugung extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    bezeichnung: string | null = null;
    ist_photovoltaik: boolean | null = null;
    reihenfolge: number | null = null;
    bemerkung: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'TechnologieStromerzeugung';
    }
}

export async function createNewTechnologieStromerzeugung(): Promise<TechnologieStromerzeugung> {
    const technologiestromerzeugung = createModel(TechnologieStromerzeugung, {});

    await technologiestromerzeugung.save();
    return technologiestromerzeugung;
}

export class TechnologieStromerzeugungCollection extends BaseCollection<TechnologieStromerzeugung> {
    protected modelCls = TechnologieStromerzeugung;

    public getModelClassName(): string {
        return 'TechnologieStromerzeugung';
    }
}
